import React, { useState } from "react";
import SelectField from "../../molecules/SelectField/SelectField";
import { getLanguageField } from "../../molecules/SettingsCard/helper";
import i18n from "../../../i18n/i18n";
import { useTranslation } from "react-i18next";

interface LanguageSelectProps {
  onLangChange?: (value: string) => void;
}

const LanguageSelect = (props: LanguageSelectProps) => {
  const { onLangChange } = props;

  const { t } = useTranslation();

  let stateLang = i18n.language;

  if (!stateLang || stateLang === "") {
    stateLang = navigator.language;
  }
  if (stateLang.includes("-")) {
    stateLang = stateLang.split("-")[0];
  }

  const [currentLang, setCurrentLang] = useState(stateLang);

  const handleLangChange = (value: string) => {
    setCurrentLang(value);
    i18n.changeLanguage(value);
    onLangChange?.(value);
  };
  return (
    <div>
      <SelectField
        field={getLanguageField(t)}
        value={currentLang}
        onChange={handleLangChange}
      />
    </div>
  );
};

export default LanguageSelect;
